<template>
  <div style="padding-bottom: 6rem;">
    <header>
      <h1>RADAR AUTO</h1>
    </header>
    <section class="radar">
      <div class="container">
        <div class="d-flex justify-content-center mb-4">
          <button class="btn-modal-edicao" data-mdb-toggle="modal" data-mdb-target="#modalEdicao"
            @click="modalEdicao()"><i class="fa-solid fa-plus"></i>
            <div>INCLUIR REGRA</div>
          </button>
        </div>
        <div class="d-flex justify-content-center mt-2 mb-4">
          <div class="search">
            <input type="text" class="form-control" ref="search" v-model="search" placeholder="Pesquisar...">
            <i class="fa-solid fa-search"></i>
            <!--  -->
          </div>
        </div>
        <div class="row">
          <div class="col">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Código Corretor</th>
                  <th>Nome Corretor</th>
                  <th>Regra</th>
                  <th>Limite Cotações</th>
                  <th>Dt. Última Alteração</th>
                  <th>Usuário Última Alteração</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="filteredData.length === 0">
                  <td colspan="7" class="text-center">Nenhum registro encontrado</td>
                </tr>
                <tr v-for="(item, index) in filteredData" :key="index">
                  <td>{{ item.cdCrtor }}</td>
                  <td>{{ item.nmCorretor }}</td>
                  <td>{{ getTextoTratado(item.tpExcec) }}</td>
                  <td>{{ item.qtLimitCallo }}</td>
                  <td>{{ item.dtUltmaAlter }}</td>
                  <td>{{ item.cdUsuroUltmaAlter }}</td>
                  <td class="acoes">
                    <button class="btn-secondary" data-mdb-toggle="modal" data-mdb-target="#modalEdicao"
                      @click="editItem(item.cdCrtor, item.tpExcec, item.qtLimitCallo)"><i
                        class="fa-solid fa-pen"></i></button>
                    <button class="btn-secondary" data-mdb-toggle="modal" data-mdb-target="#modalConfirmacao"
                      @click="modalConfirmacao(item.cdCrtor)"><i class="fa-solid fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center mt-4">
              <div class="pagination">
                <button :disabled="currentPage === 1" @click="prevPage" class="btn btn-secondary me-2"> <i
                    class="fa-solid fa-chevron-left"></i> </button>
                <button v-for="page in visiblePages" :key="page"
                  :class="['btn btn-secondary', 'me-1', { active: currentPage === page }]" @click="goToPage(page)">
                  {{ page }} </button>
                <button :disabled="currentPage === totalPages" @click="nextPage" class="btn btn-secondary ms-1"> <i
                    class="fa-solid fa-chevron-right"></i> </button>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-3"> Página {{ currentPage }} de {{ totalPages }} </div>
          </div>
        </div>
      </div>
    </section>


    <!-- modal  -->
    <div class="modal fade modal-edicao" id="modalEdicao" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="createItem">
            <div class="modal-header">
              <h5 class="modal-title">{{ modalTitle }}</h5>
              <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 mb-4">
                  <div class="form-outline">
                    <input type="text" class="form-control" ref="cdCrtor" v-model="dados.cdCrtor">
                    <label class="form-label">Código Corretor:</label>
                    <FormNotch />
                  </div>
                </div>
                <div class="col-12 mb-4">
                  <select class="form-select" ref="tpExcec" v-model="dados.tpExcec">
                    <option value="" disabled selected>Selecione o tipo de regra</option>
                    <option value="B">Bloqueado</option>
                    <option value="D">Captcha</option>
                    <option value="L">Limitado</option>
                    <option value="N">Nunca bloqueia</option>
                  </select>
                </div>
                <div class="col-12 mb-4">
                  <div class="form-outline">
                    <input type="text" class="form-control" id="" ref="qtLimitCallo" :disabled="dados.tpExcec !== 'L'"
                      v-model="dados.qtLimitCallo">
                    <label class="form-label" for="">Limite Cotações:</label>
                    <FormNotch />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button type="button" class="btn-secondary" data-mdb-dismiss="modal">CANCELAR</button>
              <button type="submit" class="btn-primary">SALVAR</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- modal delete -->
    <div class="modal fade modal-confirmacao" id="modalConfirmacao" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirm">Excluir Regra!</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Tem certeza que deseja remover o corretor <span>{{ cdCrtorSelecionado }}</span>?</p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn-secondary" data-mdb-dismiss="modal">CANCELAR</button>
            <button type="button" class="btn-primary" @click="deleteItem">SALVAR</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FormNotch from './FormNotch.vue';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';

export default {
  components: {
    FormNotch
  },
  data() {
    return {
      search: '',
      currentPage: 1,
      pageSize: 7,
      dataTable: [],
      cdCrtorSelecionado: null,
      modalTitle: '',
      filter: [],
      dados: {
        cdCrtor: "",
        tpExcec: "",
        qtLimitCallo: 0,
        qtLimitCalloCotac: 0,
      },
    };
  },

  mounted() {
    this.findAll();
  },

  methods: {
    async findAll() {
      try {
        loaderUtils.addLoarder();
        const response = await axios.get("/massificados/corporativo/gerenciador-parceiros/radar/corretor/rest");
        this.dataTable = response.data;
      } catch (error) {
        alertUtils.alertError("Erro ao buscar dados:", error);
      } finally {
        loaderUtils.removeLoader();
      }
    },

    editItem(cdCrtor, tpExcec, qtLimitCallo) {
      this.modalTitle = "Editar Regra"
      this.dados.cdCrtor = cdCrtor
      this.dados.tpExcec = tpExcec
      this.dados.qtLimitCallo = 0

      if (this.dados.tpExcec == 'L') {
        setTimeout(() => {
          this.$refs.cdCrtor.focus();
          this.$refs.qtLimitCallo.focus();
          this.dados.qtLimitCallo = 0
        }, 500);
      }
      setTimeout(() => {
        this.$refs.cdCrtor.focus();
      }, 500);

    },

    async deleteItem() {
      try {
        await axios.delete(`/massificados/corporativo/gerenciador-parceiros/radar/corretor/rest/${this.cdCrtorSelecionado}`);
        this.findAll();
        this.closeModalConfirmacao();
        alertUtils.alertSuccess("Corretor removido com sucesso!")
      } catch (error) {
        alertUtils.alertError("Erro ao remover corretor:", error);
      }
    },

    async createItem() {
      switch (true) {
        case !this.dados.cdCrtor:
          this.$refs.cdCrtor.focus();
          alertUtils.alertError("Informe o código do corretor!");
          break;

        case !this.dados.tpExcec:
          this.$refs.tpExcec.focus();
          alertUtils.alertError("Selecione o tipo de regra!");
          break;

        default:
          this.dados.qtLimitCalloCotac = this.dados.qtLimitCallo
          // console.log(this.dados)
          this.create();
      }
    },

    async create() {
      try {
        const response = await axios.post("/massificados/corporativo/gerenciador-parceiros/radar/corretor/", this.dados);
        this.findAll();
        this.closeModalEdicao();
        alertUtils.alertSuccess("Regra adicionada com sucesso!")
      } catch (error) {
        alertUtils.alertError("Erro ao enviar os dados:", error);
      }
    },

    modalEdicao() {
      this.modalTitle = "Incluir Regra"
      this.dados.cdCrtor = "";
      this.dados.tpExcec = "";
      this.dados.qtLimitCallo = 0;
      this.dados.qtLimitCalloCotac = 0;
    },

    modalConfirmacao(cdCrtor) {
      this.cdCrtorSelecionado = cdCrtor;
    },

    closeModalConfirmacao() {
      document.getElementById('modalConfirmacao').classList.remove('show');
      document.querySelector(".modal-confirmacao").style.display = "none"
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right')
      document.body.classList.remove('modal-open');
      document.querySelector(".modal-backdrop").remove();
      this.cdCrtorSelecionado = null;
    },

    closeModalEdicao() {
      document.getElementById('modalEdicao').classList.remove('show');
      document.querySelector(".modal-edicao").style.display = "none"
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right')
      document.body.classList.remove('modal-open');
      document.querySelector(".modal-backdrop").remove();
      this.dados.cdCrtor = "";
      this.dados.tpExcec = "";
      this.dados.qtLimitCallo = 0;
      this.dados.qtLimitCalloCotac = 0;
    },

    getTextoTratado(e) {
      switch (e) {
        case 'B':
        case 'T':
          return 'Bloqueado';
        case 'L':
          return 'Limitado';
        case 'N':
          return 'Nunca bloqueia';
        case 'D':
          return 'Captcha';
        default:
          return e;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToPage(page) {
      this.currentPage = page;
    }
  },

  computed: {
    filteredData() {
      const search = this.search.toLowerCase();
      return this.dataTable.filter(item => {
        return (
          (item.cdCrtor && String(item.cdCrtor).toLowerCase().includes(search)) ||
          (item.nmCorretor && String(item.nmCorretor).toLowerCase().includes(search)) ||
          (this.getTextoTratado(item.tpExcec) && this.getTextoTratado(item.tpExcec).toLowerCase().includes(search)) ||
          // (item.tpExcec && item.tpExcec.toLowerCase().includes(search)) ||
          (item.qtLimitCallo && String(item.qtLimitCallo).toLowerCase().includes(search)) ||
          (item.qtLimitCalloCotac && String(item.qtLimitCalloCotac).toLowerCase().includes(search)) ||
          (item.dtUltmaAlter && item.dtUltmaAlter.toLowerCase().includes(search)) ||
          (item.cdUsuroUltmaAlter && item.cdUsuroUltmaAlter.toLowerCase().includes(search))
        );
      }).slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },

    totalPages() {
      return Math.ceil(
        this.dataTable.filter(item => {
          const search = this.search.toLowerCase();
          return (
            (item.cdCrtor && String(item.cdCrtor).toLowerCase().includes(search)) ||
            (item.nmCorretor && String(item.nmCorretor).toLowerCase().includes(search)) ||
            (
              item.tpExcec &&
              (
                item.tpExcec.toLowerCase().includes(search) ||
                this.getTextoTratado(item.tpExcec).toLowerCase().includes(search)
              )
            ) ||
            (item.qtLimitCallo && String(item.qtLimitCallo).toLowerCase().includes(search)) ||
            (item.qtLimitCalloCotac && String(item.qtLimitCalloCotac).toLowerCase().includes(search)) ||
            (item.dtUltmaAlter && item.dtUltmaAlter.toLowerCase().includes(search)) ||
            (item.cdUsuroUltmaAlter && item.cdUsuroUltmaAlter.toLowerCase().includes(search))
          );
        }).length / this.pageSize
      );
    },
    
    visiblePages() {
      const visiblePages = [];
      if (this.totalPages <= 3) {
        for (let i = 1; i <= this.totalPages; i++) {
          visiblePages.push(i);
        }
      } else {
        const start = Math.max(1, this.currentPage - 1);
        const end = Math.min(this.totalPages, start + 2);
        for (let i = start; i <= end; i++) {
          visiblePages.push(i);
        }

        // 3 botões de página
        if (visiblePages.length < 3) {
          if (visiblePages[0] > 1) visiblePages.unshift(visiblePages[0] - 1);
          if (visiblePages[visiblePages.length - 1] < this.totalPages) {
            visiblePages.push(visiblePages[visiblePages.length - 1] + 1);
          }
        }
      }
      return visiblePages;
    }
  },

};
</script>

<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-api/css/style.css';
@import '/massificados/corporativo/gerenciador-parceiros-ui/radar/css/style.css';
</style>
